import { RECEIVE_EMPLOYMENT_BENEFITS, REQUEST_EMPLOYMENT_BENEFITS } from '../actions'
import { updateOrAddItemsById } from '../helpers'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_EMPLOYMENT_BENEFITS:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_EMPLOYMENT_BENEFITS: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = updateOrAddItemsById({ currentItems, receivedItems })

            return { ...state, isFetching: false, ...data, items }
        }

        default:
            return state
    }
}
